module.exports = __webpack_public_path__ + "static/media/icomoon.7d0eea3d.ttf";